<div class="dialog-wrapper d-flex flex-column align-items-center gap-3">
  <img [src]="'/assets/images/popup-icons/' + config.icon + '.svg'" [alt]="config.icon" srcset="" class="icon" />
  <span class="font-20 text-center" *ngIf="config.title">{{ config.title }}</span>
  <span *ngIf="config.desc" class="font-18 text-center">{{ config.desc }}</span>
  <div class="action-btns d-flex gap-3">
    <button type="button" class="btn btn-primary w-100" *ngIf="config.confirmBtnTxt" (click)="confirm()">{{ config.confirmBtnTxt }}</button>
    <button type="button" class="btn btn-sm btn-warning" *ngIf="config.denyBtnTxt" (click)="decline()">{{ config.denyBtnTxt }}</button>
  </div>
</div>
